import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components"
import AdminMenu from "../../../components/admin/menu";
import AdminPageContainer from "../../../components/admin/page-container";
import EndGameContent from "../../../components/end-game-popup/content";
import NextLink from "../../../components/next-link";
import Welcome from "../../../components/welcome";
import useLibraries from "../../../modules/user/hooks/use-libraries";
import { getEditLibraryRoute, getLibraryListRoute } from "../../routes";

const Container = styled.div`
    .list {
        position: relative;

        table {
            width: 100%;
            border-collapse: collapse;

            thead tr {
                border-bottom: 1px solid black;
            }

            td {
                padding: .3em .5em;

                &:nth-child(2n) {
                    background: #f0f0f0;
                }
            }

            tbody {
                tr:hover {
                    td {
                        background: #cdfdcd;
                    }
                }
            }

        }
    }

    .preview {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        background: rgba(0,0,0,.8);

        overflow: auto;

        font-size: 31px;

        @media (max-width: 1440px) {
            font-size: 26px;
        }

        @media (max-width: 1024px) {
            font-size: 16px;
        }
    }

    .download {
        padding: 2em;
        margin: 2em;
        border: 1px solid black;
        text-align: center;
    }
`;

export default function LibraryListPage() {
    const { libraries } = useLibraries();

    const [preview, setPreview] = useState<{ type: 'intro' | 'outro', code: string } | null>(null)

    const downloadButton = useRef<HTMLAnchorElement>(null);

    useEffect(() => {
        if (downloadButton.current) {
            let csvContent = "data:text/csv;charset=utf-8," + libraries
                .map(l => {
                    const code = l.code;
                    return [
                        code,
                        `${window.location.protocol}//${window.location.host}${process.env.PUBLIC_URL}/l/${code}`,
                        `${window.location.protocol}//${window.location.host}${process.env.PUBLIC_URL}${getEditLibraryRoute(code)}`,
                    ]
                })
                .map(e => e.join(",")).join("\n");

            var encodedUri = encodeURI(csvContent);

            downloadButton.current.setAttribute('href', encodedUri);
        }
    }, [libraries]);

    return <AdminPageContainer>
        <AdminMenu />
        <h2>Lista zarejestrowanych bibliotek</h2>
        <Container>
        <div className="download">
            <a href="data:text/csv;charset=utf-8," download="biblioteki.csv" ref={downloadButton}>Pobierz dane bibliotek</a>
        </div>
            <div className="list">
                <table>
                    <thead>
                        <tr>
                            <td>KOD</td>
                            <td>Edytuj</td>
                            <td>Powitanie</td>
                            <td>Pożegnanie</td>
                            <td>Ostatnio edytowany</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            libraries.map((lib) => {
                                return <tr key={lib.code}>
                                    <td>{lib.code}</td>
                                    <td><Link to={getEditLibraryRoute(lib.code)}>EDYCJA</Link></td>
                                    <td>
                                        <button onClick={() => setPreview({ type: 'intro', code: lib.code })}>Podgląd powitania</button>
                                    </td>
                                    <td>
                                        <button onClick={() => setPreview({ type: 'outro', code: lib.code })}>Podgląd pożegnania</button>
                                    </td>
                                    <td>
                                        {lib.updated_at || '---'}
                                    </td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>

            {
                preview && <div className='preview' onClick={() => setPreview(null)}>
                    <h1>Noc Bibliotek 2021</h1>
                    <div className="page-box">
                        <div className="page-box-content">
                            {preview.type === 'intro' && <Welcome libraryCode={preview.code} />}
                            {preview.type === 'outro' && <EndGameContent libraryCode={preview.code} />}
                        </div>
                    </div>
                    <div className="post-page-box-links">
                        <NextLink to={getLibraryListRoute()}>Zamknij</NextLink>
                    </div>
                </div>
            }
        </Container >
    </AdminPageContainer >
}
